const Actions = ({ children }) => {
  return (
    <div className='h-[48px] flex items-end gap-0.5 px-1 pb-1 absolute left-0 right-0 bottom-0 mt-auto bg-background dark:bg-input/30'>
      {children}
    </div>
  )
}

export default Actions
